import { render, staticRenderFns } from "./iButton.vue?vue&type=template&id=711c3147&"
import script from "./iButton.vue?vue&type=script&lang=js&"
export * from "./iButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports